"use strict";
/* globals module */
/**
 * @module commerceAddOnRoute
 * @description Baasic Commerce AddOn Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Product Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
//import {IProductOptions} from '../contracts';
var CommerceAddOnRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceAddOnRoute, _super);
    function CommerceAddOnRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/addons/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/addons/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/addons';
        _this.updateRoute = 'commerce/addons/{id}';
        _this.deleteRoute = 'commerce/addons/{id}';
        return _this;
    }
    /**
     * Parses find commerce AddOn route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceAddOnRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceAddOnRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceAddOnRoute.get(id, options);
     **/
    CommerceAddOnRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceAddOnRoute.create();
     **/
    CommerceAddOnRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceAddOnRoute.update(data);
     **/
    CommerceAddOnRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce product route; this URI template does not expose any additional options.
    * @method
    * @example commerceAddOnRoute.delete(data);
    **/
    CommerceAddOnRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceAddOnRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceAddOnRoute);
    return CommerceAddOnRoute;
}(common_1.BaseRoute));
exports.CommerceAddOnRoute = CommerceAddOnRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
